import { useEffect } from "react";
import Lenis from "lenis";

export function useLenis() {
    useEffect(() => {
        const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (prefersReduced) return;

        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        // Expose so ScrollToTop can jump on route change
        try { if (typeof window !== "undefined") window.__lenis = lenis; } catch {}

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        const id = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(id);
            try { if (typeof window !== "undefined" && window.__lenis === lenis) delete window.__lenis; } catch {}
            lenis.destroy();
        };
    }, []);
}
